import React from 'react';
import { createUseStyles } from 'react-jss';
import { Scrollbars } from 'react-custom-scrollbars';

import Text from '../../components/Text';
import Paper from '../../components/Paper';
import { FaCheck } from 'react-icons/fa';
import clsx from 'clsx';
import { Address } from '../../types';
import BackgroundImage from '../../components/BackgroundImage';
import { useSelector } from 'react-redux';
import { RootState } from '../../config/store';

export interface UserAddressesProps {
  addresses: Address[];
  handleChangeAddress: (address: any, index: number) => void;
  handleAddNewAddress: Function
  selectedAddress: number;
}

const UserAddresses: React.FC<UserAddressesProps> = ({
  handleChangeAddress,
  addresses,
  handleAddNewAddress,
  selectedAddress,
}) => {
  const classes = useStyles();
  const isAuthenticated = useSelector<RootState, boolean>(
    (state) => state.auth.isAuthenticated,
  );
  return (
    <Scrollbars
      style={{ width: '100%', height: '160px' }}
      renderThumbVertical={() => <div />}
    >
      <div className={classes.container}>
        {!isAuthenticated || addresses.length == 0 ?
          (
            <Paper
              withShadow={false}

              className={classes.paper}
              onClick={() => handleAddNewAddress()}

            >
              <BackgroundImage src="assets/img/placeholder/newAddress.jpg" height="80%"></BackgroundImage>
              <Text align="center" bold>Add New Address</Text>
            </Paper>

          ) : null
        }
        {addresses.map((address, index) => (
          <Paper
            className={classes.paper}
            key={address.id}
            withShadow={false}
            onClick={() => handleChangeAddress(address, index)}
          >
            {/* {parseInt(address.city.id)} */}
            <div
              className={clsx(classes.selectIconBox, {
                [classes.selected]:
                  parseInt(address.id) === selectedAddress,
              })}
            >
              {parseInt(address.id) === selectedAddress ? (
                <FaCheck />
              ) : null}
            </div>
            <Text bold>{address.label}</Text>
            <Text className="mb-1" as="span">{address.building ? address.building : null} , {address.street_name} , {address.city.name} , {address.country.iso3}</Text>
          </Paper>
        ))}
      </div>
    </Scrollbars>
  );
};

const useStyles = createUseStyles({
  container: {
    display: 'flex',
  },
  paper: {
    position: 'relative',
    padding: '1rem',
    marginRight: '1rem',
    marginTop: '0.5rem',
    cursor: 'pointer',
    maxWidth: '300px',
    minHeight: '100px',
    maxHeight: '300px',
    minWidth: '250px',
  },
  selectIconBox: {
    position: 'absolute',
    top: '10px',
    right: '10px',
    width: '20px',
    height: '20px',
    padding: '3px',
    border: '2px solid #ddd',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    fontSize: '12px',
  },
  selected: {
    color: '#5FE1A3',
    borderColor: '#5FE1A3',
  },
});

export default UserAddresses;
